export default "__VITE_ASSET__wrICTTtk__"